import React, { useState } from "react";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import supplierService from "../Services/supplierService";
import { useNavigate } from "react-router-dom";

const AddSupplier = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    name: "",
    company: "",
    country: "",
    address: "",
    accountant: "",
    status: "",
    bank_account: "",
    other_account: "",
  });

  const [errors, setErrors] = useState({
    name: false,
    company: false,
    country: false,
    address: false,
    accountant: false,
    status: false,
    bank_account: false,
    other_account: false,
  });

  const [regex, setRegex] = useState({
    name: /.{3,50}$/,
    company: /.{3,50}$/,
    country: /.{1,50}$/,
    address: /.{1,50}$/,
    accountant: /.{1,50}$/,
    status: /.{1,50}$/,
    bank_account: /.{1,50}$/,
    other_account: /.{1,50}$/,
  });

  const handleChange = (v, n) => {
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });
    console.log(hasError);
    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      supplierService.create(data).then((res) => {
        setLoading(false);
        toast.success("Supplier created successfully", { id: "2" });
        navigate("/suppliers");
      });
    }
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <p className="font-bold text-3xl text-secondary">Add Supplier</p>

      <div className="mt-10">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-4">
          <div>
            <label className={`primary-label`}>Name</label>
            <input
              value={data.name}
              name="name"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Account Manager"
              className={`primary-input ${
                errors["name"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Company</label>
            <input
              value={data.company}
              name="company"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Rep Phone No."
              className={`primary-input ${
                errors["company"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Country</label>
            <input
              value={data.country}
              name="country"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Your Country"
              className={`primary-input ${
                errors["country"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Status</label>
            <input
              value={data.status}
              name="status"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Enter Status"
              className={`primary-input ${
                errors["status"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-4 mt-4">
          <div>
            <label className={`primary-label`}>Other Account</label>
            <input
              value={data.other_account}
              name="other_account"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Other Account"
              className={`primary-input ${
                errors["other_account"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Accountant</label>
            <input
              value={data.accountant}
              name="accountant"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Enter Accountant"
              className={`primary-input ${
                errors["accountant"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Bank Account</label>
            <input
              value={data.bank_account}
              name="bank_account"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Enter Bank Account"
              className={`primary-input ${
                errors["bank_account"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-1 md:gap-4 mt-4">
          <div className="col-span-4">
            <label className={`primary-label`}>Address</label>
            <input
              value={data.address}
              name="address"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="Enter Address"
              className={`primary-input ${
                errors["address"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="flex items-center justify-center mt-12">
          <button
            onClick={() => handleSubmit()}
            className={`button-primary ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            ADD
            {loading ? <LoadingDots /> : ""}
          </button>
        </div>
      </div>
    </main>
  );
};

export default AddSupplier;
